import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import React from 'react';
import { HeroHomepageBannerStyles as S } from './HeroHomepageBanner.styles';
export var HeroHomepageLayout;
(function (HeroHomepageLayout) {
    HeroHomepageLayout["FullWidth"] = "full-width";
    HeroHomepageLayout["Slim"] = "slim";
    HeroHomepageLayout["Split"] = "split";
    HeroHomepageLayout["Wide"] = "wide";
})(HeroHomepageLayout || (HeroHomepageLayout = {}));
const HeroHomepageBannerItem = ({ cta, image, layout = HeroHomepageLayout.Slim, subtitle, title, index, }) => {
    const imageProperties = getImageProperties(layout, image);
    return (React.createElement(S.Slide, { "data-layout": layout },
        React.createElement(S.Inner, null,
            React.createElement(S.Content, null,
                React.createElement(S.Title, { as: index === 0 ? 'h1' : undefined }, title),
                subtitle && React.createElement(S.Subtitle, null, subtitle),
                cta && (React.createElement(S.Cta, { buttonType: "default", href: cta.url, icon: cta.icon, target: cta.target }, cta.text)),
                layout == HeroHomepageLayout.Split && (React.createElement(React.Fragment, null,
                    React.createElement(S.RoundedCorner, { "data-position": "top-left" }),
                    React.createElement(S.RoundedCorner, { "data-position": "bottom-left" }),
                    React.createElement(S.RoundedCorner, { "data-position": "bottom-right" })))),
            imageProperties && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { src: imageProperties.srcs.src, srcSet: imageProperties.srcs.srcSet, alt: image?.altText, sizes: imageProperties.sizes, draggable: "false" // Prevent image dragging as it interferes with the carousel
                 }))))));
    function getImageProperties(layout, image) {
        if (!image) {
            return undefined;
        }
        switch (layout) {
            case HeroHomepageLayout.FullWidth:
                return {
                    srcs: getSrcs(image, 1920, 375, 8),
                    sizes: `100vw`,
                };
            case HeroHomepageLayout.Split:
                return {
                    srcs: getSrcs(image, 720, 375, 6),
                    sizes: `${until(Device.TabletSmall)} 100vw, ${until(Device.DesktopLarge)} 50vw, 927px`,
                };
            default:
                return {
                    srcs: getSrcs(image, 1440, 375, 7),
                    sizes: `${until(Device.TabletSmall)} 100vw, ${until(Device.DesktopLarge)} 75vw, 1440px`,
                };
        }
    }
};
export default HeroHomepageBannerItem;
